import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { QuotaItem } from '../../_models/quota-item';
import { QuotaAggregate } from '../../_models/quota-aggregate';
import { QuotaService } from '../../_services/quota.service';
import { QuotaAggregateService } from '../../_services/quota-aggregate.service';
import { QuotaAggregateFilter } from '../../_models/quota-aggregate';

import { QuotaMovementsBatchService } from 'app/_services/quota-movements-batch.service';

import { NotificationsService } from '../../_services/notifications.service';
import { Profile } from '../../_models/profile';

import { GestcuotaService } from '../../_services/gestcuota.service';
import { QuotaImportedService } from '../../_services/quota-imported.service';
import { QuotaSalesService } from 'app/_services/quota-sales.service';
import { HttpErrorHandler } from 'app/shared/http-error-handler';

@Component({
  selector: 'app-quota-list-aggregate',
  templateUrl: './quota-list-aggregate.component.html',
  styleUrls: ['./_quota-list-aggregate.component.scss'],
  providers: [QuotaMovementsBatchService, QuotaSalesService],
})
export class QuotaListAggregateComponent extends List implements OnInit {
  public static currentYear = new Date().getFullYear();
  public profile: Profile;
  errorMessage: string;
  filter: QuotaAggregateFilter = new QuotaAggregateFilter();
  quotaItem: QuotaItem;
  gestcuotasAg = [];
  quotasImported = [];
  quotasSales = [];
  groupedQuotasSales = [];
  loading = false;

  constructor(
    private quotaService: QuotaService,
    private gestcuotasService: GestcuotaService,
    private quotaImportedService: QuotaImportedService,
    private quotaAgregatedService: QuotaAggregateService,
    private router: Router,
    private route: ActivatedRoute,
    private batchService: QuotaMovementsBatchService,
    private quotaSalesService: QuotaSalesService,
    protected notificationsService: NotificationsService,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(quotaAgregatedService, new QuotaAggregate(), router, route);
    this.quotaItem = new QuotaItem();
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    if (this.profile.isShipOwner()) {
      this.router.navigate(['/quotes']);
    }

    this.filter = new QuotaAggregateFilter();
    const currentYear = QuotaListAggregateComponent.currentYear;
    this.defaultFilterParams = `year=${currentYear}&campaign_year=${currentYear}&association=${this.profile['id']}`;
    this.pageSize = 10000;
    const parent = this;
    this.initList('quotas', this.filter).then((result) => {
      if (parent.profile.haveAccess('gestcuotas')) {
        parent.getStocksGestcuotas('initial&', currentYear);
      }
      if (parent.profile.haveAccess('import')) {
        parent.getStocksQuotaImported('initial&', currentYear);
      }
      if (parent.profile.haveAccess('cuotas-ventas')) {
        parent.getQuotasSales('page=1&page_size=10000&initial&', currentYear);
      }
    });
    this.defaultFilterParams = '';
    this.params['year'] = QuotaListAggregateComponent.currentYear;
  }

  toggleQuotaAggregate(quotaAggregate: QuotaAggregate, ships: any) {
    if (quotaAggregate.expanded == null) {
      this.getQuotas(quotaAggregate);
    }

    quotaAggregate.expanded = !quotaAggregate.expanded;
  }

  getQuotas(quotaAggregate) {
    const params_string = { ships: this.params.ships, year: quotaAggregate.year, stock: quotaAggregate.stock__id };
    const serialize_params = this.filter.serializeQueryParams(params_string);
    const serialize_params_gestcuota = serialize_params.replace(/ships/g, 'ship') + 'campaign_year=' + String(quotaAggregate.year);

    this.quotaService.list(1, 10000, serialize_params, '').subscribe(
      (response) => {
        quotaAggregate.details = [];
        for (const record of response.results) {
          quotaAggregate.details.push(this.quotaItem.apiMap(record));
        }
        if (this.profile.haveAccess('cuotas-ventas')) {
          this.quotasSales.forEach((quotaSale) => {
            const quota = quotaAggregate.details.find((item) => item.id === quotaSale.quota.id);
            if (quota) {
              const idsShipsQuotas = new Set(quota.ships.map((obj) => obj.id));
              const someShipInQuota = quotaSale.ships.some((obj) => idsShipsQuotas.has(obj.id));
              if (someShipInQuota) {
                quota.sale_quota_total = quotaSale.quota_total;
                quota.sale_consumed = quotaSale.consumed;
                quota.sale_pending = quotaSale.pending_quota;
              }
            }
          });
        }
        if (this.profile.haveAccess('import')) {
          this.quotaImportedService.list(1, 10000, serialize_params_gestcuota, '').subscribe(
            (responseImport) => {
              for (const importedQuota of responseImport.results) {
                let quota_exists = false;
                for (const quota of quotaAggregate.details) {
                  if (String(quota.ships[0].id) === String(importedQuota.ship__id)) {
                    quota.importedTotalWeight = importedQuota.total_weight.toFixed(2);
                    quota_exists = true;
                    break;
                  }
                }
                if (!quota_exists) {
                  const importedQuotaFormatted = {
                    ships: [
                      {
                        id: importedQuota.ship__id,
                        name: importedQuota.ship__name,
                        cfr: importedQuota.ship__cfr,
                      },
                    ],
                    stock: {
                      id: importedQuota.stock__id,
                      name: importedQuota.stock__name,
                      pseudonym: importedQuota.stock__pseudonym,
                    },
                    year: importedQuota.year,
                    importedTotalWeight: importedQuota.total_weight.toFixed(2),
                  };
                  quotaAggregate.details.push(importedQuotaFormatted);
                }
              }
            },
            (error) => this.httpErrorHandler.handleHttpError(error)
          );
        }
        if (this.profile.haveAccess('gestcuotas')) {
          this.gestcuotasService.list(1, 10000, serialize_params_gestcuota, '').subscribe(
            (response_2) => {
              for (const gestcuota of response_2.results) {
                let quota_exists = false;
                for (const quota of quotaAggregate.details) {
                  if (quota.ships[0].id === gestcuota.ship.id) {
                    quota.gestcuota_adapted_amount = gestcuota.monthData[0].adapted_amount;
                    quota.gestcuota_consumed = gestcuota.monthData[0].consumed;
                    quota.gestcuota_amount_available = gestcuota.monthData[0].amount_available;
                    quota_exists = true;
                    break;
                  }
                }
                if (!quota_exists) {
                  const gestcuota_formatted = {
                    ships: [gestcuota.ship],
                    stock: gestcuota.stock,
                    year: gestcuota.campaign_year,
                    gestcuota_adapted_amount: gestcuota.monthData[0].adapted_amount,
                    gestcuota_consumed: gestcuota.monthData[0].consumed,
                    gestcuota_amount_available: gestcuota.monthData[0].amount_available,
                    not_quota: true,
                  };
                  quotaAggregate.details.push(gestcuota_formatted);
                }
              }
            },
            (error) => this.httpErrorHandler.handleHttpError(error)
          );
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getQuotasSales(params = null, campaign_year = null) {
    const promise = new Promise((resolve) => {
      const serialize_params = params ? params : '';
      this.quotaSalesService.getQuotaSales(serialize_params).subscribe((response) => {
        console.log(response);
        this.quotasSales = response.results;
        this.getGroupedQuotasSales();
        resolve(true);
      });
    });
    return promise;
  }

  matchQuotasSales() {
    const parent = this;
    this.groupedQuotasSales.forEach(function (quotaSale) {
      const item = parent.collection.find(
        (item_x) => item_x.stock__id === quotaSale.quota__stock__id && String(item_x.year) === String(parent.params['year'])
      );
      if (item) {
        item.sale_quota_total = quotaSale.quota_total;
        item.sale_consumed = quotaSale.consumed;
        item.sale_pending = quotaSale.pending_quota;
      }
    });
  }

  getGroupedQuotasSales(): any {
    this.quotaSalesService.getGroupedQuotaSales().subscribe((response) => {
      this.groupedQuotasSales = response;
      this.matchQuotasSales();
    });
  }

  getStocksGestcuotas(params = null, campaign_year = null) {
    const parent = this;
    const promise = new Promise(function (resolve) {
      let serialize_params_gestcuota = '';
      if (params) {
        params = params.replace(/ships/g, 'ship');
        serialize_params_gestcuota = params;
        if (campaign_year) {
          serialize_params_gestcuota = params + 'campaign_year=' + String(campaign_year);
        }
      }
      parent.gestcuotasService.list(1, 10000, serialize_params_gestcuota, '').subscribe(
        (response) => {
          parent.gestcuotasAg = [];
          let gestcuotaToAppend = {
            gestcuota_adapted_amount: null,
            gestcuota_consumed: null,
            gestcuota_amount_available: null,
            stock__id: null,
            stock__name: null,
            year: null,
          };
          response.results.forEach(function (gestcuota) {
            gestcuotaToAppend = parent.gestcuotasAg.find((item) => item.stock__id === gestcuota.stock.id && item.year === gestcuota.campaign_year);
            if (gestcuotaToAppend) {
              gestcuotaToAppend.gestcuota_adapted_amount = gestcuotaToAppend.gestcuota_adapted_amount
                ? gestcuotaToAppend.gestcuota_adapted_amount + gestcuota.monthData[0].adapted_amount
                : gestcuota.monthData[0].adapted_amount;
              gestcuotaToAppend.gestcuota_consumed = gestcuotaToAppend.gestcuota_consumed
                ? gestcuotaToAppend.gestcuota_consumed + gestcuota.monthData[0].consumed
                : gestcuota.monthData[0].consumed;
              gestcuotaToAppend.gestcuota_amount_available = gestcuotaToAppend.gestcuota_amount_available
                ? gestcuotaToAppend.gestcuota_amount_available + gestcuota.monthData[0].amount_available
                : gestcuota.monthData[0].amount_available;
            } else {
              gestcuotaToAppend = {
                gestcuota_adapted_amount: gestcuota.monthData[0].adapted_amount,
                gestcuota_consumed: gestcuota.monthData[0].consumed,
                gestcuota_amount_available: gestcuota.monthData[0].amount_available,
                stock__id: gestcuota.stock.id,
                stock__name: gestcuota.stock.name,
                year: gestcuota.campaign_year,
              };
              parent.gestcuotasAg.push(gestcuotaToAppend);
            }
          });
          resolve(true);
          parent.matchGestcuotas();
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    });
    return promise;
  }

  matchGestcuotas() {
    const parent = this;
    this.gestcuotasAg.forEach(function (gestcuota) {
      const item = parent.collection.find((item_x) => item_x.stock__id === gestcuota.stock__id && String(item_x.year) === String(gestcuota.year));
      if (item) {
        item.gestcuota_adapted_amount = gestcuota.gestcuota_adapted_amount;
        item.gestcuota_consumed = gestcuota.gestcuota_consumed;
        item.gestcuota_amount_available = gestcuota.gestcuota_amount_available;
      } else {
        parent.collection.push(gestcuota);
      }
    });
    this.collection.sort(this.orderQuotasByYear).reverse();
  }
  getStocksQuotaImported(params = null, campaign_year = null) {
    const parent = this;
    const promise = new Promise(function (resolve) {
      let serializeParamsQuotaImported = '';
      if (params) {
        params = params.replace(/ships/g, 'ship');
        serializeParamsQuotaImported = params;
        if (campaign_year) {
          serializeParamsQuotaImported = params + 'campaign_year=' + String(campaign_year);
        }
      }
      parent.quotaImportedService.list(1, 10000, serializeParamsQuotaImported, '').subscribe(
        (response) => {
          parent.quotasImported = [];
          response.results.forEach(function (quotaImported) {
            let quotaImportedToAppend = parent.quotasImported.find(
              (item) => String(item.stock__id) === String(quotaImported.stock__id) && String(item.year) === String(quotaImported.year)
            );
            if (quotaImportedToAppend) {
              quotaImportedToAppend.importedTotalWeight = quotaImportedToAppend.importedTotalWeight
                ? parseInt(parseInt(quotaImportedToAppend.importedTotalWeight, 10).toFixed(2), 10) +
                  parseInt(parseInt(quotaImported.total_weight, 10).toFixed(2), 10)
                : parseInt(parseInt(quotaImported.total_weight, 10).toFixed(2), 10);
            } else {
              quotaImportedToAppend = {
                importedTotalWeight: parseInt(quotaImported.total_weight.toFixed(2), 10),
                stock__id: quotaImported.stock__id,
                stock__name: quotaImported.stock__name,
                year: quotaImported.year,
              };
              parent.quotasImported.push(quotaImportedToAppend);
            }
          });
          resolve(true);
          parent.matchQuotaImported();
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    });
    return promise;
  }

  matchQuotaImported() {
    const parent = this;
    this.quotasImported.forEach(function (importedQuota) {
      const item = parent.collection.find(
        (item_x) => String(item_x.stock__id) === String(importedQuota.stock__id) && String(item_x.year) === String(importedQuota.year)
      );
      if (item) {
        item.importedTotalWeight = importedQuota.importedTotalWeight;
      }
      // else {
      //   parent.collection.push(importedQuota);
      // }
    });
    this.collection.sort(this.orderQuotasByYear).reverse();
  }
  deleteQuota(quota: QuotaItem) {
    this.quotaService.delete(quota.id).subscribe(
      (empty) => {
        this.list(this.currentPage);
        this.notificationsService.notify('success', 'Eliminar cuota', 'La cuota se ha eliminado correctamente');
      },
      (error) => {
        this.notificationsService.notify('error', 'Eliminar cuota', error.body[0]);
      }
    );
  }

  newBatch(mode) {
    this.batchService.create({ mode: mode }).subscribe(
      (response) => {
        this.router.navigate([`/quotas-batchs/${response['id']}`]);
      },
      (error) => {
        this.notificationsService.notify('error', 'Crear comunicación', error.body[0]);
      }
    );
  }

  public applyFilter(params) {
    if (!this.loading) {
      this.params = params;
      const params_string = { ships: params.ships, year: params.year, stock: params.stock, association: this.profile['id'] };
      const serialize_params = this.filter.serializeQueryParams(params_string);
      this.loading = true;
      this.quotaAgregatedService.list(1, 10000, serialize_params, '').subscribe(
        (response) => {
          this.collection = [];
          for (const record of response.results) {
            this.collection.push(record);
          }
          if (this.profile.haveAccess('gestcuotas')) {
            this.getStocksGestcuotas(serialize_params, params.year);
          }
          if (this.profile.haveAccess('import')) {
            this.getStocksQuotaImported(serialize_params, params.year);
          }
          this.loading = false;
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    }
  }

  applyOrdering(param) {
    const parent = this;
    switch (param) {
      case 'ship':
        this.collection.forEach(function (quota) {
          if (quota.details !== undefined) {
            quota.details.sort(parent.orderQuotasByShip);
          }
        });
        break;
      case '-ship':
        this.collection.forEach(function (quota) {
          if (quota.details !== undefined) {
            quota.details.sort(parent.orderQuotasByShip).reverse();
          }
        });
        break;
      case 'stock':
        this.collection.sort(this.orderQuotasByStock);
        break;
      case '-stock':
        this.collection.sort(this.orderQuotasByStock).reverse();
        break;
      case 'year':
        this.collection.sort(this.orderQuotasByYear);
        break;
      case '-year':
        this.collection.sort(this.orderQuotasByYear).reverse();
        break;
      default:
        break;
    }
  }

  orderQuotasByShip(x, y) {
    return String(x.ships[0].name).localeCompare(String(y.ships[0].name));
  }

  orderQuotasByStock(x, y) {
    return String(x.stock__name).localeCompare(String(y.stock__name));
  }

  orderQuotasByYear(x, y) {
    return x.year.toString().localeCompare(y.year.toString());
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-list-aggregate/quota-list-aggregate.component.ts